require('./profitabilityTab.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');
const LineChartProfitability = require('components/d3Components/lineChartProfitability/lineChartProfitability');

// @ commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');

// @ helper
const { formatText } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');

// @ constants
const { DATE_FORMAT_ES } = require('constants/index');
const ANNUAL_PROFITABILITY_YEARS_LIMIT = 5;

class ProfitabilityTab extends React.Component {

    getCategoryAnualValue(columnYear, product, valueRender) {
        const historicalPerformanceSeries = product.get('benchmark').get('category').size
            ? product.get('benchmark').get('category')
            : null
        if (!historicalPerformanceSeries) {
            return '-'
        }
        return valueRender(columnYear, historicalPerformanceSeries, 'Return', 'Value');
    }

    getCategoryPrimaryIndexAnualValue(columnYear, product, valueRender) {
        const historicalPerformanceSeries = product.get('benchmark').get('categoryPrimaryIndex').size
            ? product.get('benchmark').get('categoryPrimaryIndex')
            : null

        if (!historicalPerformanceSeries) {
            return '-'
        }

        return valueRender(columnYear, historicalPerformanceSeries, 'Return', 'Value');
    }


    getColumns(renderMethod, product, valueRender, type) {
        const biggestYear = (new Date()).getFullYear() - 1;
        const fullYears = Array.apply(null, Array(ANNUAL_PROFITABILITY_YEARS_LIMIT)).map(function (_, i) {return i;});

        return fullYears.map((yearFound, index) => (
            <OKTableCell
                className="profitability-tab__table-annual-cell"
                key={'yearsFounds-' + type + index}
            >
                {renderMethod((biggestYear - index), product, valueRender)}
            </OKTableCell>
        ))
    }

    getFoundAnualValue(columnYear, product, valueRender) {
        const historicalPerformanceSeries = product.get('annualProfitability').get('historicalPerformanceSeries').size
            ? product.get('annualProfitability').get('historicalPerformanceSeries')
            : null
        if (!historicalPerformanceSeries) {
            return '-'
        }
        return valueRender(columnYear, historicalPerformanceSeries, 'Return', 'Value');
    }

    getHistoricalPerformanceValue(columnYear, historicalPerformanceSeries, dataContainerField, dataField) {
        const historicalPerformanceSeriesByYear = historicalPerformanceSeries.find(historicalPerformance => historicalPerformance.get('Frequency') === 'Y').get(dataContainerField);
        const currentYearPerformance = historicalPerformanceSeriesByYear.find(historicalPerformanceYear => new Date(historicalPerformanceYear.get('Date')).getFullYear() === columnYear);
        if (!currentYearPerformance) {
            return '-'
        }
        return parseFloat(currentYearPerformance.get(dataField)).toFixed(2) + '%';
    }

    getProfitAcum(trailingPerformance, time) {
        const profitAcum = formatAmount(trailingPerformance.get(time));

        return profitAcum ? profitAcum + '%' : '-'

    }

    buildAnnualTableHeader() {
        const yearsback = Array.apply(null, Array(ANNUAL_PROFITABILITY_YEARS_LIMIT)).map(function (_, i) {return i;});
        const biggestYear = (new Date()).getFullYear() - 1;

        return yearsback.map((year, index) => {
            return (
                <OKTableCell
                    key={index}
                    asHeader={true}
                    className="profitability-tab__table-annual-header-cell profitability-tab__table-annual-header-cell"
                >
                    {biggestYear - index}
                </OKTableCell>
            );
        });
    }

    render() {
        const PREFIX = 'broker-profitabilityTab'

        const eurEvolutionTitle = formatText(`${PREFIX}EUREvolutionTitle`);
        const annualProfitabilityTitle = formatText(`${PREFIX}AnnualProfitabilityTitle`);
        const fundLabel = formatText(`${PREFIX}FundLabel`);
        const benchmarkLabel = formatText(`${PREFIX}BenchmarkLabel`);

        const accumulateProfitabilityTitle = formatText(`${PREFIX}AccumulateProfitabilityTitle`);
        const ytdLabel = formatText(`${PREFIX}YTDLabel`);
        const oneMonthLabel = formatText(`${PREFIX}OneMonthLabel`);
        const threeMonthsLabel = formatText(`${PREFIX}ThreeMonthsLabel`);
        const sixMonthsLabel = formatText(`${PREFIX}SixMonthsLabel`);

        const { product } = this.props;
        const lastDatePriceHistory = product.getIn(['priceHistory', 'lastDate']);
        const priceDetails = product.getIn(['priceHistory', 'priceDetails']);
        const trailingPerformance = product.get('trailingPerformance');
        const annualTableHeaderBlock = this.buildAnnualTableHeader();
        const currencyId = product.getIn(['growthOf10K', 'currencyId']);
        return (
            <div className="profitability-tab">
                {priceDetails.size !== 0 &&
                    <section className="profitability-tab__section">
                        <header className="profitability-tab__section-header">
                            <h2 className="profitability-tab__section-title">
                                {eurEvolutionTitle}
                            </h2>
                            <div className="profitability-tab__date-container">
                                <i className="icon icon-calendario broker-markets-calendar__period-icon-calendar" />
                                <span className="profitability-tab__date">
                                    {moment(lastDatePriceHistory).format(DATE_FORMAT_ES)}
                                </span>
                            </div>
                        </header>
                        {/*
                            Here we are setting the with of the graph to 100% and
                            wrapping it inside a div with overflow x to create an
                            horizintal scroll.
                        */}
                        <div style={{ overflowX: 'auto' }}>
                            <div className="profitability-tab__graph-container" style={{ width: '100%' }}>
                                <LineChartProfitability
                                    width="1100"
                                    height="280"
                                    dataset={priceDetails}
                                    chartType="history"
                                    currencyId={currencyId}
                                />
                            </div>
                        </div>
                    </section>
                }

                <section className="profitability-tab__section">
                    <header className="profitability-tab__section-header">
                        <h2 className="profitability-tab__section-title">
                            {annualProfitabilityTitle}
                        </h2>
                        <div className="profitability-tab__date-container">
                            <i className="icon icon-calendario broker-markets-calendar__period-icon-calendar" />
                            <span className="profitability-tab__date">
                                {moment(lastDatePriceHistory).format(DATE_FORMAT_ES)}
                            </span>
                        </div>
                    </header>

                    <OKTable
                        id="profitability-tab-table-annual"
                        className="profitability-tab__table-annual"
                    >
                        <OKTableRow
                            asHeader={true}
                            className="profitability-tab__table-annual-header-row"
                        >
                            <OKTableCell
                                asHeader={true}
                                className="profitability-tab__table-annual-header-cell profitability-tab__table-annual-header-cell--first-column"
                            />
                            {annualTableHeaderBlock}
                        </OKTableRow>

                        <OKTableRow>
                            <OKTableCell className="profitability-tab__table-annual-cell profitability-tab__table-annual-cell--first-column">
                                {fundLabel}
                            </OKTableCell>
                            {this.getColumns(this.getFoundAnualValue, product, this.getHistoricalPerformanceValue, 'found')}
                        </OKTableRow>

                        <OKTableRow>
                            <OKTableCell className="profitability-tab__table-annual-cell profitability-tab__table-annual-cell--first-column">
                                {benchmarkLabel}
                            </OKTableCell>
                            {this.getColumns(this.getCategoryAnualValue, product, this.getHistoricalPerformanceValue, 'benchmark')}
                        </OKTableRow>
                    </OKTable>
                </section>

                <section className="profitability-tab__section">
                    <header className="profitability-tab__section-header">
                        <h2 className="profitability-tab__section-title">
                            {accumulateProfitabilityTitle}
                        </h2>
                        <div className="profitability-tab__date-container">
                            <i className="icon icon-calendario broker-markets-calendar__period-icon-calendar" />
                            <span className="profitability-tab__date">
                                {moment(lastDatePriceHistory).format(DATE_FORMAT_ES)}
                            </span>
                        </div>
                    </header>

                    <OKTable
                        id="profitability-tab-table-accumulate"
                        className="profitability-tab__table-accumulate"
                    >
                        <OKTableRow
                            asHeader={true}
                            className="profitability-tab__table-accumulate-header-row"
                        >
                            <OKTableCell
                                asHeader={true}
                                className="profitability-tab__table-accumulate-header-cell profitability-tab__table-accumulate-header-cell--first-column"
                            />
                            <OKTableCell
                                asHeader={true}
                                className="profitability-tab__table-accumulate-header-cell profitability-tab__table-accumulate-header-cell--second-column"
                            >
                                {fundLabel}
                            </OKTableCell>
                        </OKTableRow>

                        <OKTableRow>
                            <OKTableCell className="profitability-tab__table-accumulate-cell profitability-tab__table-accumulate-cell--first-column">
                                {ytdLabel}
                            </OKTableCell>
                            <OKTableCell className="profitability-tab__table-accumulate-cell">
                                {this.getProfitAcum(trailingPerformance, 'ytd')}
                            </OKTableCell>
                        </OKTableRow>

                        <OKTableRow>
                            <OKTableCell className="profitability-tab__table-accumulate-cell profitability-tab__table-accumulate-cell--first-column">
                                {oneMonthLabel}
                            </OKTableCell>
                            <OKTableCell className="profitability-tab__table-accumulate-cell">
                                {this.getProfitAcum(trailingPerformance,'oneMonth')}
                            </OKTableCell>
                        </OKTableRow>

                        <OKTableRow>
                            <OKTableCell className="profitability-tab__table-accumulate-cell profitability-tab__table-accumulate-cell--first-column">
                                {threeMonthsLabel}
                            </OKTableCell>
                            <OKTableCell className="profitability-tab__table-accumulate-cell">
                                {this.getProfitAcum(trailingPerformance,'threeMonths')}
                            </OKTableCell>
                        </OKTableRow>

                        <OKTableRow>
                            <OKTableCell className="profitability-tab__table-accumulate-cell profitability-tab__table-accumulate-cell--first-column">
                                {sixMonthsLabel}
                            </OKTableCell>
                            <OKTableCell className="profitability-tab__table-accumulate-cell">
                                {this.getProfitAcum(trailingPerformance,'sixMonths')}
                            </OKTableCell>
                        </OKTableRow>
                    </OKTable>
                </section>
            </div>
        );
    }
}

ProfitabilityTab.propTypes = {
    product: PropTypes.object
};

module.exports = ProfitabilityTab;
